import { gql } from "@apollo/client";

export const INSTALL_AI_ADDON_MUTATION = gql`
 mutation InstallAIAddon($input: CreateCompanyAIAddonInput!) {
     createCompanyAIAddon(input: $input) {
         id
         companyId
         aiAddonId
         status
         startDate
         nextBillingDate
         aiAddon {
             id
             name
             description
             pricingType
             amount
             currency
         }
     }
 }
`;

// Uninstall AI Addon Mutation (needs companyAIAddon id, not aiAddonId)

export const UNINSTALL_AI_ADDON_MUTATION = gql`
 mutation UninstallAIAddon($input: DeleteCompanyAIAddonInput!) {
     deleteCompanyAIAddon(input: $input) {
         success
         message
     }
 }
`;

// Update Company Plan Mutation

export const UPDATE_COMPANY_PLAN_MUTATION = gql`
 mutation UpdateCompanyPlan($input: UpdateCompanyPlanInput!) {
     updateCompanyPlan(input: $input) {
         id
         company_id
         plan_id
         stripe_customer_id
         stripe_subscription_id
         stripe_transaction_id
         stripe_transaction_status
         status
         start_date
         next_due_date
         ends_on
         created_at
         updated_at
         plan {
             id
             name
             description
             amount
             currency
             interval
             interval_count
             features
             limits
             active
         }
     }
 }
`;

// Update Company Mutation
